module.exports = __webpack_public_path__ + "img/btn-header-reload.b64a1a58.svg";